import { Button as ClientbaseButton } from '@clientbase/clientbase-library'
import {
  AppBar,
  Button,
  MenuItem as MenuItemMUI,
  styled,
  Toolbar as ToolbarMUI
} from '@mui/material'

type AppBarMUIProps = {
  isExpandedDrawer: boolean
  isExpandedMobileMenu: boolean
  showTopGlobalInfo?: boolean
}

type ToolbarProps = {
  isExpandedMobileMenu: boolean
}

export const AppBarMUI = styled(AppBar)<AppBarMUIProps>(
  ({ theme, isExpandedDrawer, isExpandedMobileMenu, showTopGlobalInfo }) => ({
    '@media (min-width: 770px)': {
      width: isExpandedDrawer ? 'calc(100% - 260px)' : 'calc(100% - 100px)'
    },
    alignItems: 'center',
    borderLeft: `1px solid ${theme.palette.neutral['800']}`,
    backgroundColor: theme.palette.neutral['800'],
    boxShadow: `0px 1px 0px ${theme.palette.neutral[700]}`,
    flexShrink: 'initial',
    height: isExpandedMobileMenu ? '100vh' : 80,
    ...(showTopGlobalInfo && { top: '50px', marginBottom: '50px' }),
    transition: 'height 0.5s ease-in-out',
    [theme.breakpoints.down(770)]: {
      ...(showTopGlobalInfo && { top: '50px' }),
      backgroundColor: theme.palette.neutral[800],
      boxShadow: 'none',
      height: isExpandedMobileMenu ? '100vh' : 80,
      zIndex: 1000
    },
    [theme.breakpoints.down(450)]: {
      ...(showTopGlobalInfo && { top: '90px' })
    },
    zIndex: 999
  })
)

export const Toolbar = styled(ToolbarMUI)<ToolbarProps>(
  ({ isExpandedMobileMenu, theme }) => ({
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    height: isExpandedMobileMenu ? '100vh' : 80,
    transition: 'height 0.5s ease-in-out',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    width: '100%',
    [theme.breakpoints.down(770)]: {
      height: isExpandedMobileMenu ? '100vh' : 80
    }
  })
)

export const ToolbarContentWrapper = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  gap: 15
}))
export const EndIconsWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8
}))

export const BalanceButton = styled(Button)(() => ({
  ['&:focus']: {
    borderColor: 'black'
  },
  ['&:hover, &:focus']: {
    background: 'none'
  },
  alignItems: 'flex-start',
  border: '1px solid transparent',
  cursor: 'pointer',
  flexDirection: 'column'
}))

export const MenuItem = styled(MenuItemMUI)(() => ({
  ['&:last-child']: {
    marginTop: 4
  },
  alignItems: 'center',
  display: 'flex',
  gap: 8,
  minWidth: 300
}))

export const Actions = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10
}))

export const AssistantButton = styled(ClientbaseButton)(() => ({
  minWidth: 'auto',
  padding: '8px',
  borderRadius: '12px',
  background: 'rgba(15, 247, 194, 0.1)',
  boxShadow: '0px 1.27px 15.27px 0px rgba(0, 0, 0, 0.05)',
  backdropFilter: 'blur(15px)',
  WebkitBackdropFilter: 'blur(15px)',
  border: '1px solid rgba(255, 255, 255, 0.4)',
  cursor: 'pointer',
  '&:hover': {
    background: 'rgba(220, 220, 220, 0.10)',
    boxShadow: '0 2px 20px 0 rgba(0, 0, 0, 0.08)'
  }
}))
